import { CollectionLayout } from "@features/layout";

export const CollectionsPage = () => {
  return <CollectionLayout />;
};
